<div class="component-accountPage loginPage">

<!--    tooltip="Zapnout náhodná pozadí na přihlašovací obrazovce"-->
    <ca-toggle-advanced-edit
            class="input-switch"
            [toggleModel]="randomBcgEnabled"
            message="Povolit změnu pozadí"
            [labels]="false"
            name="login-alternative-bcg"
            (callback)="onChangeAlternativeBcg($event.$toggle);">
    </ca-toggle-advanced-edit>

    <div class="component-accountForm">

        <form method="post" #loginForm="ngForm" (ngSubmit)="submitCredentials(loginForm)">

            <h1>
                <a href="https://www.cleverassets.cz/" id="test-linkCleverAssets">Clever&deg;&#x200b;Assets&prime;</a>
            </h1>

            <fieldset>

                <label class="fullwidth">
                    Uživatelské jméno (e-mail)
                    <input
                            placeholder="zadejte e-mail"
                            type="email"
                            autocorrect="off"
                            autocapitalize="none"
                            autocomplete="username"
                            [(ngModel)]="username"
                            name="username"
                            autofocus
                            (blur)="onUsernameBlur()"
                            [pattern]="emailRegex"
                            required>
                </label>

                <br>

                <label class="fullwidth">
                    Heslo
                    <input
                            placeholder="zadejte heslo"
                            type="password"
                            autocomplete="current-password"
                            ngModel
                            name="password"
                            required>
                </label>

                <br>

                <input
                        type="checkbox"
                        name="keep"
                        id="stayLogged"
                        ngModel>
                <label
                        for="stayLogged"
                        class="showAsCheckbox withLabel">
                    Přihlásit trvale
                </label>

                <div class="divSubmit">
                    <input type="submit" name="login" value="Přihlásit" class="button-primary" id="test-loginButton" />
                    <ca-loading loaderType="parcels" [loadState]="sending" loaderEffect="shimmer"></ca-loading>

                    <div *ngIf="invalidUsernameFormat" id="test-loginError" class="loginError">Uživatelské jméno není platná emailová adresa.</div>
                    <div *ngIf="invalidCredentials" id="test-loginError" class="loginError">Chybné přihlašovací údaje, opakujte zadání.</div>
                    <div *ngIf="serverError" id="test-loginError" class="loginError">Chyba serveru, zkuste to prosím později.</div>
                </div>

                <p>
                    Máte problémy s přihlášením? <a (click)="showPasswordReset();" id="test-forgetPasswordLink">Zapomněli jste heslo?</a>
                </p>
            </fieldset>
        </form>

    </div>

    <p class="versionInfo">
        <a href="https://www.cleverassets.cz/" title="verze aplikace: {{appVersion}}&#010;datum sestavení: {{buildDate}}">Aplikaci CleverAssets</a>
        vyvíjí a provozuje společnost <a href="https://www.cleverfarm.cz/" id="test-linkCleverFarm">CleverFarm a.s.</a>
    </p>

</div>


